export default __webpack_public_path__ + "static/media/soundPack6.6eb792cc.png";